module.exports = __webpack_public_path__ + "img/parralax-bg-2.e38bcc56.png";